<template>
   <div class="row bgc-wrapper margin-top-42">
    <div class="col-lg-12 col-md-12 col-sm-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id = "nom_details_corr"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#NomineeDetailsCorrection"
          >
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Nominee Details Correction</h3>
      </div>
    </div>
    <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="NomineeDetailsCorrection">
        <div class="row">
            <!--PA Nominee Name starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="nomineeDetailsCorrectionData.paNomineeName.visibility">
                <div class="row form-group">
                    <float-label label="PA Nominee Name" :fixed="isFloat(nomineeDetailsCorrectionData.paNomineeName.value)"> 
                        <input
                            v-model="nomineeDetailsCorrectionData.paNomineeName.value"
                            v-evolvews="nomineeDetailsCorrectionData.paNomineeName"
                            type="text"
                            maxlength="30"
                            v-on:keydown="onlyCharSpace"
                            class="form-control"
                            placeholder="PA Nominee Name"
                        />
                    </float-label>
                    <span class="error-text" v-if="nomineeDetailsCorrectionData.paNomineeName.errorText !== ''">
                        {{nomineeDetailsCorrectionData.paNomineeName.errorText}}</span>
                </div>
            </div>
            <!--PA Nominee Name ends-->
            <!-- PA Nominee Relation starts-->
            <div class=" col-lg-3 col-md-3 col-sm-6" v-if="nomineeDetailsCorrectionData.paNomineeRelation.visibility">
                <div class="row form-group">
                    <float-label label="PA Nominee Relation" :fixed="isFloat(nomineeDetailsCorrectionData.paNomineeRelation.value)">
                        <select
                        class="form-control"
                        placeholder="PA Nominee Relation"
                        v-model="nomineeDetailsCorrectionData.paNomineeRelation.value"
                        v-evolvews="nomineeDetailsCorrectionData.paNomineeRelation"
                        >
                            <!-- <option disabled selected value>PA Nominee Relation</option> -->
                            <option disabled value='' v-if="nomineeDetailsCorrectionData.paNomineeRelation.value==''">PA Nominee Relation</option>
                            <option disabled :value='null' v-if="nomineeDetailsCorrectionData.paNomineeRelation.value==null">PA Nominee Relation</option>
                            <option v-for="relation in domainValues.initMotorDomainLists.nomineeRelations" :key="relation.code" :value="relation.code">{{relation.name}}</option>
                        </select>
                    </float-label>
                    <span
                        class="error-text"
                        v-if="nomineeDetailsCorrectionData.paNomineeRelation.errorText !== ''"
                        >{{ nomineeDetailsCorrectionData.paNomineeRelation.errorText }}</span>
                </div>
            </div>
            <!-- PA Nominee Relation ends-->
            <!--Nominee DOB starts-->
            <!-- <div class="col-lg-3 col-md-3 col-sm-6">
                <div class="row form-group">
                    <float-label label="Nominee DOB" :fixed="isFloat(nomineeDetailsCorrectionData.nomineeDob.value)">
                        <datepicker
                        v-model="nomineeDetailsCorrectionData.nomineeDob.value"
                        v-evolvews="nomineeDetailsCorrectionData.nomineeDob"
                        :typeable="true"
                        format="dd/MM/yyyy"
                        placeholder="Nominee DOB"
                        :input-class="isInputError(nomineeDetailsCorrectionData.nomineeDob.errorText)"
                        @selected="checkError(nomineeDetailsCorrectionData.nomineeDob,false)"
                        @input="checkError(nomineeDetailsCorrectionData.nomineeDob,false)"
                        ></datepicker>
                    </float-label>
                    <span
                        class="error-text"
                        v-if="nomineeDetailsCorrectionData.nomineeDob.errorText !== ''"
                    >{{nomineeDetailsCorrectionData.nomineeDob.errorText}}</span>
                </div>
            </div> -->
            <!--Nominee DOB ends-->
            <!--PA Nominee Allocation (%) starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="nomineeDetailsCorrectionData.paNomineeAllocationPercentage.visibility">
                <div class="row form-group">
                    <float-label label="PA Nominee Allocation (%)" :fixed="isFloat(nomineeDetailsCorrectionData.paNomineeAllocationPercentage.value)"> 
                        <input
                            v-model="nomineeDetailsCorrectionData.paNomineeAllocationPercentage.value"
                            v-evolvews="nomineeDetailsCorrectionData.paNomineeAllocationPercentage"
                            type="text"
                            v-on:keydown="onlyNumber"
                            disabled
                            @blur="checkError(nomineeDetailsCorrectionData.paNomineeAllocationPercentage)"
                            :class="{
                                'bgc-error-field':nomineeDetailsCorrectionData.paNomineeAllocationPercentage.errorText !=='',
                            }"
                            maxlength="3"              
                            class="form-control"
                            placeholder="PA Nominee Allocation (%)"
                        />
                    </float-label>
                    <span class="error-text" v-if="nomineeDetailsCorrectionData.paNomineeAllocationPercentage.errorText !== ''">
                        {{nomineeDetailsCorrectionData.paNomineeAllocationPercentage.errorText}}</span>
                </div>
            </div>
            <!--PA Nominee Allocation (%) ends-->
        </div>
    </div>
    </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import functions from "@/../../masters/functions.js";
// import base from "@/../../masters/base.js";
// import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
// import vSelect from "vue-select";
import { reactive, onUpdated } from "@vue/composition-api";
export default {
  name: "NomineeDetailsCorrection",
  props: ["nomineeDetailsCorrectionData","domainValues","getSavedQuoteData"],
  components: {
    FloatLabel,
    Datepicker
  },
  setup(props, context) {
    let state = reactive({});
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const isFloat = functions.isFloat;
    const onlyNumber =  functions.onlyNumber;
    const onlyCharSpace =  functions.onlyCharSpace;
    onUpdated(()=>{
      let progressStep = 0;
      Object.values(props.nomineeDetailsCorrectionData).forEach(obj => {
        if(obj.stepsMandatory){
          if(obj.value && !obj.errorText){
            progressStep++;
          }
        }
      })
      context.parent.updateSteps(progressStep);
      if(props.getSavedQuoteData.riskDetails.cpaApplicability !== 'S'){
        context.parent.enableCalculatePremiumBtn('nomineeDetailsCorrection');
      }  
    })
    return {
      state,
      isFloat,
      checkError,
      isInputError,
      onlyNumber,
      onlyCharSpace,
    };
  },
   directives: {
    evolvews: functions.evolvews
  }
};
</script>
